import { render } from "./GeneralLedgerOld.vue?vue&type=template&id=21bc4b53&scoped=true"
import script from "./GeneralLedgerOld.vue?vue&type=script&lang=js"
export * from "./GeneralLedgerOld.vue?vue&type=script&lang=js"

import "./GeneralLedgerOld.vue?vue&type=style&index=0&id=21bc4b53&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21bc4b53"]])

export default __exports__